<template>
  <div id="app">
    <Main></Main>
  </div>
</template>

<script>

import Main from './components/Random.vue'
// import Main from './components/Dashboard.vue'
// import Main from './components/Chart.vue'
// import Main from './components/Main.vue'

export default {
  name: 'App',
  components: {
    Main
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@media (min-width: 1200px) {
  .container {
    width: 2048px;
  }
}
</style>
